module.exports = __webpack_public_path__ + "img/carrito.cdab41f2.svg";